import client from '../utils/client';
import { gql } from '@apollo/client';
import { VolumeLicenseInfoFragment } from '../utils/fragments';

type Error = 'NETWORK_ERROR' | 'UNAUTHORIZED' | 'COMPANY_ALREADY_EXISTS';

const createVolumeLicense = async ({
	companyId,
	companyDepartmentId,
	audienceCategoryId,
	isLimited,
	limitedUnit,
	limitedFactor,
	numberOfLicenses,
	productIds,
	finishInDays,
}: {
	companyId: string;
	companyDepartmentId?: string;
	audienceCategoryId: string;
	isLimited: boolean;
	limitedUnit?: 'YEAR' | 'MONTH' | 'WEEK' | 'DAY';
	limitedFactor?: number;
	numberOfLicenses: number;
	productIds: string[];
	finishInDays?: number;
}): Promise<{ success: true; error: undefined } | { success: false; error: Error }> => {
	try {
		const { errors } = await client.mutate({
			mutation: gql`
				mutation CreateVolumeLicense(
					$companyId: ID!
					$companyDepartmentId: ID
					$audienceCategoryId: ID!
					$isLimited: Boolean!
					$limitedUnit: TimeUnit
					$limitedFactor: Int
					$numberOfLicenses: Int!
					$productIds: [ID!]!
					$finishInDays: Int
				) {
					createVolumeLicense(
						companyId: $companyId
						companyDepartmentId: $companyDepartmentId
						audienceCategoryId: $audienceCategoryId
						isLimited: $isLimited
						limitedUnit: $limitedUnit
						limitedFactor: $limitedFactor
						numberOfLicenses: $numberOfLicenses
						productIds: $productIds
						finishInDays: $finishInDays
					) {
						...VolumeLicenseInfoFragment
					}
				}
				${VolumeLicenseInfoFragment}
			`,
			variables: {
				companyId,
				companyDepartmentId,
				isLimited,
				limitedUnit,
				limitedFactor,
				numberOfLicenses,
				productIds,
				audienceCategoryId,
				finishInDays,
			},
			// TODO: CurrentUser is only necessary when creating a companyVolumeLicense
			refetchQueries: ['VolumeLicenses', 'CurrentUser'],
		});
		if (errors) {
			return {
				success: false,
				error: errors[0]?.extensions?.code as Error,
			};
		}
		return {
			success: true,
			error: undefined,
		};
	} catch (e) {
		if (e && e.networkError) return { success: false, error: 'NETWORK_ERROR' };
		throw e;
	}
};

export default createVolumeLicense;
